import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App";
import { store } from "./app/store";
import "./index.css";
import "./landing.css";
import "./styles/modern-dashboard.css";
import "./styles/modern-forms.css";
import "./styles/modern-login.css";
import "./styles/modern-admin-shell.css";
import "./styles/new-premium-design.css";
import "./styles/melona-premium.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
